export default {
  'memberAreaJourney.title': '会員履歴',
  'memberAreaJourney.period': '有効期間',
  'memberAreaJourney.no_records': '会員履歴がまだありません',
} as Record<string, string>;
